@if (hasVariant()) {
	<div class="variant-fields">
		<div class="variant-header">
			<span class="variant-label"><i class="pi pi-users text-[9px]"></i> Variant</span>
			@if (data()?.namesMapKey) {
				<span class="variant-key">{{ data()?.namesMapKey }}</span>
			}
			<button type="button" class="variant-remove" (click)="removeVariant()" title="Remove variant">
				<i class="pi pi-times" style="font-size: 7px;"></i>
			</button>
		</div>

		<div class="variant-row">
			<div class="variant-field">
				<label>Key (argument)</label>
				<p-select
					[options]="argKeyOptions()"
					[ngModel]="data()?.key ?? ''"
					(ngModelChange)="setKey($event)"
					optionLabel="label"
					optionValue="value"
					[editable]="true"
					appendTo="body"
					styleClass="w-full"
					placeholder="Select argument..."
				/>
			</div>
			<div class="variant-field">
				@if (mode() === 'scene') {
					<label>General Scene (fallback)</label>
					<p-select
						[options]="siblingOptions()"
						[ngModel]="data()?.generalSceneSlug ?? ''"
						(ngModelChange)="setGeneralSlug($event)"
						optionLabel="label"
						optionValue="value"
						[editable]="true"
						appendTo="body"
						styleClass="w-full"
						placeholder="Fallback scene..."
					/>
				} @else {
					<label>General Audio (fallback)</label>
					<p-select
						[options]="siblingOptions()"
						[ngModel]="data()?.generalAudioSlug ?? ''"
						(ngModelChange)="setGeneralSlug($event)"
						optionLabel="label"
						optionValue="value"
						[editable]="true"
						appendTo="body"
						styleClass="w-full"
						placeholder="Fallback audio..."
					/>
				}
			</div>
		</div>
	</div>
}
